import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const claimConversation = {
  name: "claimConversation" as const,
  input: z.object({ conversationId: zExt.objectId() }),
  output: z.object({ acquired: z.boolean() }),
};
